// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Vanuatu */
const VU = /^(?:(?:[58]\d|7[0-7])\d{5})$/;

export default VU;
